import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { svg, text_s, mq } from '_utils/styles';
import { spacing } from '_utils/props';

export const Container = styled.nav`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  @media print {
    display: none;
  }
`;

const item = () => `
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
`;

const itemSpacing = ({ theme }) => `
  ${spacing({ theme, $my: 0, $mx: '2px' })}

  ${mq('md')} {
    ${spacing({ theme, $my: 0, $mx: '4px' })}
  }
`;

/* ie11 cant do margin auto in flex */
const ie11Margin = (side) => `
  @media all and (-ms-high-contrast: none) {
    margin-${side}: 16px;
  }
`;

export const Prev = styled(Link)`
  ${item}

  margin-right: auto;

  ${ie11Margin('right')}

  &:active,
  &:hover {
    border-radius: 9999px;
    background-color: ${({ theme }) => theme.colors.background.senary};
  }
`;

export const PrevDisabled = styled.span`
  margin-right: auto;

  ${ie11Margin('right')}
`;

export const Next = styled(Link)`
  ${item}

  margin-left: auto;

  ${ie11Margin('left')}

  &:active,
  &:hover {
    border-radius: 9999px;
    background-color: ${({ theme }) => theme.colors.background.senary};
  }
`;

export const NextDisabled = styled.span`
  margin-left: auto;

  ${ie11Margin('left')}
`;

export const ArrowWrapper = styled.span`
  ${svg(7, 12)}
  width: 7px;

  ${Prev} & {
    transform: rotate(180deg)
  }

  ${Prev}:hover &,
  ${Next}:hover & {
    path {
      fill: ${({ theme }) => theme.colors.button.primary.backgroundHover};
    }
  }

  path {
    fill: ${({ theme }) => theme.colors.element.secondary};
  }
`;

export const Current = styled.span`
  ${text_s}
  ${item}
  ${({ theme }) => itemSpacing({ theme })}
  border-radius: 9999px;
  background-color: ${({ theme }) => theme.colors.background.senary};
  font-weight: bold;
  user-select: none;
`;

export const Page = styled(Link)`
  ${text_s}
  ${item}
  ${({ theme }) => itemSpacing({ theme })}
  min-width: 32px;
  padding: 8px;
  color: inherit;
  user-select: none;


  &:active{
    color: ${({ theme }) => theme.colors.element.tertiary};
  }

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.element.tertiary};
    }
  }
`;

export const Gap = styled.span`
  ${text_s}
  ${({ theme }) => itemSpacing({ theme })}
  user-select: none;
  &:before {
    content: '…';
  }
`;
